import toastContainer from './toast-container';

export const MODULE_NAME = 'toast';
export { default as store } from './toast.store';
export const components = { toastContainer };
